/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  TelematicsCreateRequestDto,
  TelematicsDeviceInfo,
  TelematicsDeviceInfoPageDto,
  TelematicsProviderPageDto,
  TelematicsUpdateRequestDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType , BodyType } from '../../../../custom-instance';




/**
 * @summary getAllDevices
 */
export const getAllDevices = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<TelematicsDeviceInfoPageDto>(
      {url: `/fleet/telematics/v1/devices`, method: 'GET', signal
    },
      );
    }
  

export const getGetAllDevicesQueryKey = () => {
    return [`/fleet/telematics/v1/devices`] as const;
    }

    
export const getGetAllDevicesQueryOptions = <TData = Awaited<ReturnType<typeof getAllDevices>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDevices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllDevicesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllDevices>>> = ({ signal }) => getAllDevices(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllDevices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllDevices>>>
export type GetAllDevicesQueryError = ErrorType<unknown>


export function useGetAllDevices<TData = Awaited<ReturnType<typeof getAllDevices>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDevices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDevices>>,
          TError,
          Awaited<ReturnType<typeof getAllDevices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllDevices<TData = Awaited<ReturnType<typeof getAllDevices>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDevices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDevices>>,
          TError,
          Awaited<ReturnType<typeof getAllDevices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllDevices<TData = Awaited<ReturnType<typeof getAllDevices>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDevices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getAllDevices
 */

export function useGetAllDevices<TData = Awaited<ReturnType<typeof getAllDevices>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDevices>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllDevicesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary createDevice
 */
export const createDevice = (
    telematicsCreateRequestDto: BodyType<TelematicsCreateRequestDto>,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TelematicsDeviceInfo>(
      {url: `/fleet/telematics/v1/devices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: telematicsCreateRequestDto, signal
    },
      );
    }
  


export const getCreateDeviceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDevice>>, TError,{data: BodyType<TelematicsCreateRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDevice>>, TError,{data: BodyType<TelematicsCreateRequestDto>}, TContext> => {

const mutationKey = ['createDevice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDevice>>, {data: BodyType<TelematicsCreateRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  createDevice(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof createDevice>>>
    export type CreateDeviceMutationBody = BodyType<TelematicsCreateRequestDto>
    export type CreateDeviceMutationError = ErrorType<unknown>

    /**
 * @summary createDevice
 */
export const useCreateDevice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDevice>>, TError,{data: BodyType<TelematicsCreateRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDevice>>,
        TError,
        {data: BodyType<TelematicsCreateRequestDto>},
        TContext
      > => {

      const mutationOptions = getCreateDeviceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary getDeviceByDeviceId
 */
export const getDeviceByDeviceId = (
    deviceId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TelematicsDeviceInfo>(
      {url: `/fleet/telematics/v1/devices/by-device-id/${deviceId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDeviceByDeviceIdQueryKey = (deviceId?: string,) => {
    return [`/fleet/telematics/v1/devices/by-device-id/${deviceId}`] as const;
    }

    
export const getGetDeviceByDeviceIdQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceByDeviceId>>, TError = ErrorType<unknown>>(deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceByDeviceId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceByDeviceIdQueryKey(deviceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceByDeviceId>>> = ({ signal }) => getDeviceByDeviceId(deviceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(deviceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceByDeviceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeviceByDeviceIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceByDeviceId>>>
export type GetDeviceByDeviceIdQueryError = ErrorType<unknown>


export function useGetDeviceByDeviceId<TData = Awaited<ReturnType<typeof getDeviceByDeviceId>>, TError = ErrorType<unknown>>(
 deviceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceByDeviceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceByDeviceId>>,
          TError,
          Awaited<ReturnType<typeof getDeviceByDeviceId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeviceByDeviceId<TData = Awaited<ReturnType<typeof getDeviceByDeviceId>>, TError = ErrorType<unknown>>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceByDeviceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceByDeviceId>>,
          TError,
          Awaited<ReturnType<typeof getDeviceByDeviceId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeviceByDeviceId<TData = Awaited<ReturnType<typeof getDeviceByDeviceId>>, TError = ErrorType<unknown>>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceByDeviceId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getDeviceByDeviceId
 */

export function useGetDeviceByDeviceId<TData = Awaited<ReturnType<typeof getDeviceByDeviceId>>, TError = ErrorType<unknown>>(
 deviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceByDeviceId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeviceByDeviceIdQueryOptions(deviceId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary getDeviceByVehicle
 */
export const getDeviceByVehicle = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TelematicsDeviceInfo>(
      {url: `/fleet/telematics/v1/devices/vehicles/${vehicleId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDeviceByVehicleQueryKey = (vehicleId?: string,) => {
    return [`/fleet/telematics/v1/devices/vehicles/${vehicleId}`] as const;
    }

    
export const getGetDeviceByVehicleQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceByVehicle>>, TError = ErrorType<unknown>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceByVehicle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceByVehicleQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceByVehicle>>> = ({ signal }) => getDeviceByVehicle(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceByVehicle>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeviceByVehicleQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceByVehicle>>>
export type GetDeviceByVehicleQueryError = ErrorType<unknown>


export function useGetDeviceByVehicle<TData = Awaited<ReturnType<typeof getDeviceByVehicle>>, TError = ErrorType<unknown>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceByVehicle>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceByVehicle>>,
          TError,
          Awaited<ReturnType<typeof getDeviceByVehicle>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeviceByVehicle<TData = Awaited<ReturnType<typeof getDeviceByVehicle>>, TError = ErrorType<unknown>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceByVehicle>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeviceByVehicle>>,
          TError,
          Awaited<ReturnType<typeof getDeviceByVehicle>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeviceByVehicle<TData = Awaited<ReturnType<typeof getDeviceByVehicle>>, TError = ErrorType<unknown>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceByVehicle>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getDeviceByVehicle
 */

export function useGetDeviceByVehicle<TData = Awaited<ReturnType<typeof getDeviceByVehicle>>, TError = ErrorType<unknown>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeviceByVehicle>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDeviceByVehicleQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary updateDevice
 */
export const updateDevice = (
    vehicleId: string,
    telematicsUpdateRequestDto: BodyType<TelematicsUpdateRequestDto>,
 ) => {
      
      
      return customInstance<TelematicsDeviceInfo>(
      {url: `/fleet/telematics/v1/devices/vehicles/${vehicleId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: telematicsUpdateRequestDto
    },
      );
    }
  


export const getUpdateDeviceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDevice>>, TError,{vehicleId: string;data: BodyType<TelematicsUpdateRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateDevice>>, TError,{vehicleId: string;data: BodyType<TelematicsUpdateRequestDto>}, TContext> => {

const mutationKey = ['updateDevice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDevice>>, {vehicleId: string;data: BodyType<TelematicsUpdateRequestDto>}> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  updateDevice(vehicleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof updateDevice>>>
    export type UpdateDeviceMutationBody = BodyType<TelematicsUpdateRequestDto>
    export type UpdateDeviceMutationError = ErrorType<unknown>

    /**
 * @summary updateDevice
 */
export const useUpdateDevice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDevice>>, TError,{vehicleId: string;data: BodyType<TelematicsUpdateRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDevice>>,
        TError,
        {vehicleId: string;data: BodyType<TelematicsUpdateRequestDto>},
        TContext
      > => {

      const mutationOptions = getUpdateDeviceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary getAllProviders
 */
export const getProviders = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<TelematicsProviderPageDto>(
      {url: `/fleet/telematics/v1/providers`, method: 'GET', signal
    },
      );
    }
  

export const getGetProvidersQueryKey = () => {
    return [`/fleet/telematics/v1/providers`] as const;
    }

    
export const getGetProvidersQueryOptions = <TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProvidersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProviders>>> = ({ signal }) => getProviders(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof getProviders>>>
export type GetProvidersQueryError = ErrorType<unknown>


export function useGetProviders<TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviders>>,
          TError,
          Awaited<ReturnType<typeof getProviders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProviders<TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviders>>,
          TError,
          Awaited<ReturnType<typeof getProviders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProviders<TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getAllProviders
 */

export function useGetProviders<TData = Awaited<ReturnType<typeof getProviders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProvidersQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary deleteDevice
 */
export const deleteDevice = (
    vehicleId: string,
 ) => {
      
      
      return customInstance<boolean>(
      {url: `/fleet/telematics/v1/vehicles/${vehicleId}/devices`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDeviceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDevice>>, TError,{vehicleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDevice>>, TError,{vehicleId: string}, TContext> => {

const mutationKey = ['deleteDevice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDevice>>, {vehicleId: string}> = (props) => {
          const {vehicleId} = props ?? {};

          return  deleteDevice(vehicleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDevice>>>
    
    export type DeleteDeviceMutationError = ErrorType<unknown>

    /**
 * @summary deleteDevice
 */
export const useDeleteDevice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDevice>>, TError,{vehicleId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDevice>>,
        TError,
        {vehicleId: string},
        TContext
      > => {

      const mutationOptions = getDeleteDeviceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    